var ContextNav = require('../../../components/ContextNav').ContextNav;
var ContextNavItem = require('../../../components/ContextNav').ContextNavItem;
var React = require('react');
var scrollTo = require('../../../helpers/scrollTo');
require('./Progress.css');

class Progress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress:0,
      documentHeight:0
    }
  }

  componentDidMount() {
    var documentHeight = document.querySelector('.pubr-main').scrollHeight;
    this.setState({
      documentHeight: documentHeight
    })
    document.addEventListener('scroll', (e) => {
      var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var percentage = (((scrollTop + 100) / documentHeight) * 100) + 1;

      if(documentHeight - scrollTop + 50 < window.innerHeight) {
        percentage = 100;
      }
      this.setState({
        progress: percentage
      })
    });
  }

  handleGotoChapter(position, id) {
    scrollTo(document.getElementById(id).offsetTop - 100, 2000);
    window.history.pushState(null, null, `#${id}`);
    document.getElementById(id).focus();
  }

  render() {

    var headings = this.props.sections.map((item) => {
      
      // var position = Math.round((item.position / this.state.documentHeight) * 100);
     
      var className;
      if(item.position <= this.state.progress) {
        className = 'pubr-progress__completion__dot pubr-progress__completion__dot--complete';
      }
      else {
        className = 'pubr-progress__completion__dot';
      };
      return (
        <ContextNav customClickEvent={this.handleGotoChapter.bind(this, item.position, item.sectionId)} actionEventType="hover" className={className} style={{left:item.position + '%'}} align="bottom" customTrigger=" " key={item.sectionId}>
          <ContextNavItem handler={this.handleGotoChapter.bind(this, item.position, item.sectionId)} text={item.sectionHeading} />
        </ContextNav>
      );
    });
    var width = this.state.progress + '%';
    return(
      <header className="pubr-footer">
        <div className  ="pubr-footer__inner">
          <div className  ="pubr-footer__inner__wrap">
            <div className="pubr-progress">
              <nav aria-label="Avsnitt" className="pubr-progress__completion" style={{width:width}}>
                {headings}
              </nav>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

module.exports = Progress;



// WEBPACK FOOTER //
// ./src/modules/reader/components/Progress.js